/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
const i=Symbol("isCSVGraphicOrigin");function n(n){return!!n&&i in n}export{n as isCSVGraphicOrigin,i as isCSVGraphicOriginSymbol};
